import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup, useClosePopupOnNavigation } from '@gem/popups';

import { ReportForm } from '../../components/ReportForm/ReportForm';
import { IReportGroupPopupParams, useReportGroupPresenter } from './ReportGroupPopup.presenter';

export const ReportGroupPopup: FC<ICommonPopupsProps<IReportGroupPopupParams>> = observer(
  (props) => {
    const { t } = useTranslation();
    const presenter = useReportGroupPresenter(props);
    useClosePopupOnNavigation(props.popupInstance);

    return (
      <Popup
        title={t('common_report')}
        isOpened
        onClose={presenter.onClose}
      >
        <ReportForm
          title={
            presenter.group?.isChannel
              ? t('content_moderation_channel')
              : t('content_moderation_group')
          }
          onSubmit={presenter.onSubmit}
        />
      </Popup>
    );
  }
);
